import React from 'react';
import {
  all, call, fork, put, takeLatest,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import actions from '../actions/transactions';
import rf from '../../requests/RequestFactory';
import utils from '../../common/utils';
import {
  FETCH_TRANS_ERROR,
  FETCH_TRANS_ERROR_FILTER,
  FETCH_TRANS_HISTORY,
  FETCH_USER_TRANS_HISTORY,
  FETCH_USER_VOLUME_24H,
  SEARCH_TRANS_ERROR,
  FETCH_WITHDRAWAL_HISTORY,
  SEARCH_TRANSACTION_BY_ID,
  WITHDRAWAL,
  VERIFY_TRANSACTION,
  ACCEPT_TRANSACTION, FETCH_TRANS_FILTER_HISTORY,
  DELETE_TRANSACTION,
  FETCH_VERIFY_HISTORY,
} from '../actions/transactions/action_types';
import userAction from '../actions/user';

function* fetchTransactionHistory(action) {
  try {
    const { data, total_count: totalCount } = yield call((params) => rf.getRequest('TransactionRequest')
      .fetchTransactionHistory(params), action.params);
    yield put(actions.onFetchTransactionHistorySucceed(data, totalCount));
    if (isFunction(action.callback)) {
      yield action.callback(totalCount);
    }
  } catch (err) {
    yield put(actions.onFetchTransactionHistoryFailed(err));
  }
}

function* fetchTransactionErrors(action) {
  try {
    const { data, total } = yield call((params) => rf.getRequest('TransactionRequest').fetchTransactionErrors(params), action.params);
    yield put(actions.fetchTransErrorActionSucceed(data, total));
    if (isFunction(action.callback)) {
      yield action.callback(total);
    }
  } catch (err) {
    yield put(actions.fetchTransErrorActionFailed(err));
  }
}

function* searchTransactionErrors(action) {
  try {
    const { data, total } = yield call((params) => rf.getRequest('TransactionRequest').searchTransactionErrors(params), action.params);
    yield put(actions.searchTransErrorActionSucceed(data, total));
    if (isFunction(action.callback)) {
      yield action.callback(total);
    }
  } catch (err) {
    yield put(actions.searchTransErrorActionFailed(err));
  }
}

function* fetchTransactionErrorsFilter(action) {
  try {
    const { data, total } = yield call((params) => rf.getRequest('TransactionRequest').fetchTransactionErrorsFilter(params), action.params);
    yield put(actions.fetchTransErrorFilterActionSucceed(data, total));
    if (isFunction(action.callback)) {
      yield action.callback(total);
    }
  } catch (err) {
    if (isFunction(action.callback)) {
      yield action.callback(0);
    }
    yield put(actions.fetchTransErrorFilterActionFailed(err));
  }
}

function* fetchUserTransactionHistory(action) {
  try {
    const { data, total_count: totalCount } = yield call((params) => rf.getRequest('TransactionRequest')
      .fetchUserTransactionHistory(params), action.params);
    yield put(actions.fetchUserTransHistoryActionSucceed(data, totalCount));
    if (isFunction(action.callback)) {
      yield action.callback(totalCount);
    }
  } catch (err) {
    yield put(actions.fetchUserTransHistoryActionFailed(err));
  }
}

function* withdrawal(action) {
  try {
    const resp = yield call((params) => rf.getRequest('TransactionRequest')
      .withdrawal(params), action.params.data);

    yield put(actions.onWithdrawalSucceed(resp.data));
    yield put(actions.fetchUserVolume24hAction(action.params.data));
    yield put(userAction.userBalancesAction());
    yield utils.showNotification('Thông báo', 'Chuyển tiền thành công');
  } catch (err) {
    yield put(actions.onWithdrawalFailed(err));
  } finally {
    if (action.callback) {
      yield action.callback();
    }
  }
}

function* fetchWithdrawalHistory(action) {
  try {
    const resp = yield call((params) => rf.getRequest('TransactionRequest')
      .fetchWithdrawalHistory(params), action.params.data);

    yield put(actions.onFetchTransactionHistorySucceed(resp.data, resp.total_count));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.onFetchTransactionHistoryFailed(err));
  }
}

function* fetchUserVolume24h(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('TransactionRequest')
      .fetchLimit24h(params), action.params);

    yield put(actions.fetchUserVolume24hActionSucceed(data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.fetchUserVolume24hActionFailed(err));
  }
}

function* searchTransById(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('TransactionRequest')
      .searchTransById(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback(data);
    }
  } catch (err) {
    console.error(err);
    yield put(actions.searchTransByIDActionFailed(err));
  }
}

function* verifyTransaction(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('TransactionRequest').verifyTransaction(params), action.data);
    action.callback();
    yield put(actions.verifyTransactionSucceed(data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.verifyTransactionFailed(err));
  }
}

function* deleteTransaction(action) {
  try {
    yield call((params) => rf.getRequest('TransactionRequest').deleteTransaction(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  } catch (err) {
    console.log(err.message, '@: err.message');
    yield put(actions.deleteTransactionFailed(err));
  }
}

function* acceptTransaction(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('TransactionRequest')
      .acceptTransaction(params), action.data);
    utils.showNotification('Thành công', 'Đã xác nhận giao dịch và chuyển tiền');
    yield put(actions.acceptTransactionSucceed(data));
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.acceptTransactionFailed(err));
  }
}

function* fetchTransactionFilterHistory(action) {
  try {
    const { data, total_count: totalCount } = yield call((params) => rf.getRequest('TransactionRequest')
      .fetchTransactionFilterHistory(params), action.params);
    yield put(actions.onFetchTransactionHistorySucceed(data, totalCount));
    if (isFunction(action.callback)) {
      yield action.callback(totalCount);
    }
  } catch (err) {
    yield put(actions.onFetchTransactionHistoryFailed(err));
  }
}

function* fetchVerifyHistory(action) {
  try {
    const { data, total } = yield call((params) => rf.getRequest('TransactionRequest')
      .fetchVerifyHistory(params), action.params);
    yield put(actions.fetchVerifyHistorySucceed(data, total));
    if (isFunction(action.callback)) {
      yield action.callback(total);
    }
  } catch (err) {
    yield put(actions.fetchVerifyHistoryFailed(err));
  }
}

function* watchTransaction() {
  yield takeLatest(FETCH_TRANS_HISTORY, fetchTransactionHistory);
  yield takeLatest(FETCH_TRANS_FILTER_HISTORY, fetchTransactionFilterHistory);
  yield takeLatest(FETCH_TRANS_ERROR, fetchTransactionErrors);
  yield takeLatest(SEARCH_TRANS_ERROR, searchTransactionErrors);
  yield takeLatest(FETCH_TRANS_ERROR_FILTER, fetchTransactionErrorsFilter);
  yield takeLatest(FETCH_USER_TRANS_HISTORY, fetchUserTransactionHistory);
  yield takeLatest(WITHDRAWAL, withdrawal);
  yield takeLatest(FETCH_WITHDRAWAL_HISTORY, fetchWithdrawalHistory);
  yield takeLatest(FETCH_USER_VOLUME_24H, fetchUserVolume24h);
  yield takeLatest(SEARCH_TRANSACTION_BY_ID, searchTransById);
  yield takeLatest(VERIFY_TRANSACTION, verifyTransaction);
  yield takeLatest(ACCEPT_TRANSACTION, acceptTransaction);
  yield takeLatest(DELETE_TRANSACTION, deleteTransaction);
  yield takeLatest(FETCH_VERIFY_HISTORY, fetchVerifyHistory);
}

export default function* rootSaga() {
  yield all([fork(watchTransaction)]);
}
